let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fWoat")).then(() => parcelRequire('Li5l0'));